import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import {
    AppBar,
    Toolbar,
    Grid,
    Paper,
    Box,
    Typography,
    IconButton,
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputAdornment,
    Avatar,
    Tooltip,
    Divider,
} from "@material-ui/core";

import {
    makeStyles,
} from "@material-ui/core/styles";

import {
    NotificationsNone,
    HelpOutline,
    SettingsOutlined,
    Search,
    Refresh,
    Home,
    PersonOutline,
    TrendingUp,
    Storefront,
    ShoppingCartOutlined,
    PeopleOutline,
    BuildOutlined,
    AttachMoney,
    AssessmentOutlined,
    AccountBalanceWalletOutlined,
    Inventory2Outlined,
    CalendarToday,
    KeyboardArrowDown,
    Menu as MenuIcon,
    Language,
    ArrowUpward,
    BarChart,
    CategoryOutlined,
    ReceiptLongOutlined,
    Store,
    Receipt,
} from "@material-ui/icons";

import "./Dashboard.css";
import { sto } from "../../Context/InshData";
import axios from "axios";
import { uri } from "../../help/Api";
import moment from "moment";
import { Autocomplete } from "@material-ui/lab";
import useFetchURL from "../../components/Hooks/useFetchURL";
import { getLatestSevenDayDate } from "../../services/SalesChartSrvice";
import { LatestSales } from "./components";
import MostSoled from "./components/MostSoldProducts/MostSoled";
import YearSales from "./components/YearSales/YearSales";
import { useStylesLbl } from "../../St/Reports/UseStyle";


const useStyles = makeStyles((theme) => ({
    root: {
        direction: "rtl",
        minHeight: "100vh",
        background: "#f4f8fd",
        fontFamily: "Tahoma, Arial, sans-serif",
        overflowX: "hidden",
    },

    toolbar: {
        minHeight: 55,
        display: "flex",
        justifyContent: "space-between",
        padding: "0 18px",
        background: "linear-gradient(100deg, #08749a 0%, #078bb5 55%, #079fc5 100%)",
    },

    headerIcon: {
        color: "#fff",
        padding: 8,
    },

    headerButton: {
        color: "#fff",
        fontWeight: 700,
        fontSize: 12,
        whiteSpace: "nowrap",
    },

    card: {
        background: "#fff",
        border: "1px solid #e3ebf5",
        borderRadius: 10,
        boxShadow: "0 3px 12px rgba(31, 76, 125, 0.055)",
        overflow: "hidden",
    },

    cardTitle: {
        fontSize: 15,
        fontWeight: 800,
        color: "#173b70",
    },

    cardSubTitle: {
        fontSize: 11,
        color: "#8b9db5",
    },

    kpiCard: {
        minHeight: 126,
        height: "100%",
        position: "relative",
        padding: "18px 17px",
        borderRadius: 12,
        overflow: "hidden",
        border: "1px solid rgba(200, 218, 239, 0.65)",
        boxShadow: "0 4px 12px rgba(31, 76, 125, 0.055)",
    },

    kpiIcon: {
        width: 48,
        height: 48,
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        flexShrink: 0,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    },

    filter: {
        "& .MuiOutlinedInput-root": {
            height: 38,
            background: "#fff",
            borderRadius: 8,
            fontSize: 12,
        },

        "& .MuiInputLabel-outlined": {
            fontSize: 12,
        },
    },

    bottomButton: {
        borderRadius: 7,
        color: "#fff",
        background: "#078c94",
        padding: "7px 15px",
        fontSize: 12,
        fontWeight: 700,
        minWidth: 0,
        whiteSpace: "nowrap",

        "&:hover": {
            background: "#057a83",
        },
    },
}));


// ======================================================
// البيانات
// استبدل هذه البيانات ببيانات API الخاصة بنظامك.
// ======================================================


const kpiData = (allData) => [

    {
        id: 1,
        title: "purchases",
        value: allData ? (parseFloat(allData.purches?.total ?? 0) - parseFloat(allData?.return_purches?.total ?? 0)).toFixed(2) : 0.0,
        prefix: "RS",
        decimals: 2,
        icon: <Storefront />,
        color: "#f04452",
        background: "linear-gradient(135deg, #fff1f2 0%, #ffe9ed 100%)",
        iconBackground: "#f04452",
        change: 0,
    },

    {
        id: 2,
        title: "sales",
        value: allData ? (parseFloat(allData.sales?.total ?? 0) - parseFloat(allData?.return_sales?.total ?? 0)).toFixed(2) : 0.0,
        prefix: "RS",
        decimals: 2,
        icon: <AccountBalanceWalletOutlined />,
        color: "#19a66a",
        background: "linear-gradient(135deg, #edfff5 0%, #e4f9ee 100%)",
        iconBackground: "#20a65b",
        change: 0,
    },

    {
        id: 3,
        title: "sales-customers",
        value: 0,
        prefix: "",
        decimals: 0,
        icon: <PeopleOutline />,
        color: "#1688f8",
        background: "linear-gradient(135deg, #edf7ff 0%, #e4f3ff 100%)",
        iconBackground: "#1688f8",
        change: 16,
    },

    {
        id: 4,
        title: "expenses",
        value: allData ? allData.Expenses : 0.0,
        prefix: "RS",
        decimals: 0,
        icon: <BuildOutlined />,
        color: "#607d8b",
        background: "linear-gradient(135deg, #f4f8fb 0%, #edf3f7 100%)",
        iconBackground: "#78909c",
        change: 0,
    },

    {
        id: 5,
        title: "total-profit",
        value: allData?.Profit,
        prefix: "RS",
        decimals: 2,
        icon: <AttachMoney />,
        color: "#5946df",
        background: "linear-gradient(135deg, #f4f0ff 0%, #ece9ff 100%)",
        iconBackground: "#6651e8",
        change: 0,
    },

    {
        id: 6,
        title: "total-revenue",
        value: allData?.Revenues,
        prefix: "",
        decimals: 0,
        icon: <Receipt />,
        color: "#6450df",
        background: "linear-gradient(135deg, #f3f1ff 0%, #ebe9ff 100%)",
        iconBackground: "#6651e8",
        change: 0,
    },
];


const collectedAmounts = [
    {
        id: 1,
        name: "cash2",
        amount: 0,
        color: "#16a36b",
        background: "#f0fbf6",
    },
    {
        id: 2,
        name: "network",
        amount: 0,
        color: "#1688f8",
        background: "#f0f7ff",
    },
    {
        id: 3,
        name: "bank2",
        amount: 0,
        color: "#7752e8",
        background: "#f6f2ff",
    },
    {
        id: 4,
        name: "foward",
        amount: 0,
        color: "#f08a26",
        background: "#fff7ef",
    },
];




const weekDays = [
    "11 أكتوبر",
    "12 أكتوبر",
    "13 أكتوبر",
    "14 أكتوبر",
    "15 أكتوبر",
    "16 أكتوبر",
    "17 أكتوبر",
];


const months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
];


// ======================================================
// أدوات مساعدة
// ======================================================

function formatNumber(value, decimals = 2) {
    return Number(value || 0).toLocaleString("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}


function money(value, decimals = 2) {
    return `RS ${formatNumber(value, decimals)}`;
}


// ======================================================
// البطاقة الإحصائية
// ======================================================

function KpiCard({ item, classes, allData }) {
    const { t } = useTranslation(["forms"]);
    return (
        <Paper
            elevation={0}
            className="oc-kpi-card"
            style={{
                background: item.background,
                borderColor: `${item.color}22`,
            }}
        >
            <div className="oc-kpi-content">

                <div
                    className="oc-kpi-icon"
                    style={{ background: item.iconBackground }}
                >
                    {item.icon}
                </div>

                <div className="oc-kpi-info">

                    <Typography
                        className={classes.cardTitle}
                        style={{ color: "#24456e" }}
                    >
                        {t(item.title)}
                    </Typography>

                    <Typography
                        className="oc-kpi-value"
                        style={{ color: "#163d70" }}
                    >
                        {/* {item.prefix ? `${item.prefix} ` : ""}
                        { item.id==1 ?(parseFloat(allData.purches?.total ?? 0) - parseFloat(allData?.return_purches?.total ?? 0)).toFixed(2):
                        item.id==2 ?(parseFloat(allData.sales?.total ?? 0) - parseFloat(allData?.return_sales?.total ?? 0)).toFixed(2):
                        item.id==4 ?parseFloat(allData.Expenses).toFixed(2):
                        item.id==5 ?parseFloat(allData?.Profit).toFixed(2):
                        item.id==5 ?parseFloat(allData?.Revenues).toFixed(2):
                        0
                        } */}
                        {formatNumber(item.value, item.decimals)}
                    </Typography>

                    <div className="oc-kpi-comparison">
                        <span>{t("compared-to-previous-period")}</span>

                        <span
                            style={{
                                color: item.change > 0 ? "#15a56a" : "#8a9bb0",
                                fontWeight: 800,
                            }}
                        >
                            {item.change > 0 ? (
                                <>
                                    <ArrowUpward
                                        style={{
                                            fontSize: 13,
                                            verticalAlign: "middle",
                                        }}
                                    />
                                    {item.change}%
                                </>
                            ) : (
                                "0%"
                            )}
                        </span>
                    </div>

                </div>

                <div
                    className="oc-kpi-watermark"
                    style={{ color: item.color }}
                >
                    {item.icon}
                </div>

            </div>
        </Paper>
    );
}


// ======================================================
// عنوان البطاقة
// ======================================================

function CardHeader({ title, icon, action }) {
    return (
        <div className="oc-card-header">

            <div className="oc-card-title">

                {icon && (
                    <span className="oc-card-title-icon">
                        {icon}
                    </span>
                )}

                <Typography variant="subtitle1">
                    {title}
                </Typography>

            </div>

            {action || null}

        </div>
    );
}


// ======================================================
// المخزون الأقل كمية
// ======================================================

function LowStockCard({ classes, Safes }) {
    const { t } = useTranslation(["forms"]);
    const [safe, setSafe] = useState(Safes[0]);
    const { data, fetching } = useFetchURL({
        ...{
            url:
                uri +
                `TaswyaBasicData/lowestCountInSafe?safe=${safe.id}
            &&branch=${-1}`,
            dependencyArray: [safe],
        },
    });

    return (
        <Paper className={`${classes.card} oc-panel`} elevation={0}>

            <CardHeader
                title={t("low-stock-items")}
                icon={<Store />}
                action={
                    <Button
                        size="small"
                        color="primary"
                        className="oc-small-action"
                    >
                        {t("show-all")}
                    </Button>
                }
            />

            <div className="oc-stock-table">

                <div className="oc-stock-header">

                    <span>{t("item")}</span>

                    <span>{t("code")}</span>

                    <span>{t("remaining-quantity")}</span>

                </div>

                {data.map((item) => (
                    <div className="oc-stock-row" key={item.name}>
                        
                        <div className="oc-stock-name">

                            <span className="oc-stock-product-icon">
                                <CategoryOutlined />
                            </span>

                            <span title={item.name}>
                                {item.name}
                            </span>

                        </div>
                        <div className="oc-stock-code">
                            {item.id}
                        </div>

                        <div className="oc-stock-quantity">
                            {item.Qtys}
                        </div>


                    </div>
                ))}

            </div>

            <div className="oc-panel-footer">

                <Button
                    size="small"
                    color="primary"
                    endIcon={<KeyboardArrowDown />}
                >
                    {t("show-more")}
                </Button>

            </div>

        </Paper>
    );
}


// ======================================================
// المبالغ المحصلة
// ======================================================

function CollectedAmountsCard({
    classes,
    data,
    fetching,
    curr
}) {
    const { t } = useTranslation(["forms"]);
    return (
        <Paper className={`${classes.card} oc-panel`} elevation={0}>

            <CardHeader
                title={t("collected-amounts")}
                icon={<AccountBalanceWalletOutlined />}
            />

            <div className="oc-collected-list">

                {collectedAmounts.map((item) => (
                    <div
                        key={item.id}
                        className="oc-collected-row"
                        style={{ background: item.background }}
                    >

                        <span
                            className="oc-collected-icon"
                            style={{ color: item.color }}
                        >
                            <AccountBalanceWalletOutlined />
                        </span>

                        <Typography
                            className="oc-collected-name"
                            style={{ color: item.color }}
                        >
                            {t(item.name)}
                        </Typography>

                        <Typography className="oc-collected-amount">
                            {item.id == 1 ? money(data?.total_cash, 0) : item.id == 2 ? money(data?.total_network, 0) :
                                item.id == 3 ? money(data?.total_bank, 0) : money(data?.total_agel, 0)}
                        </Typography>

                    </div>
                ))}

            </div>

        </Paper>
    );
}




// ======================================================
// الشريط العلوي
// ======================================================

function DashboardHeader({
    classes,
    rptParams,
    setRptParams,
    Branches,
    fetching,
    viewHandle,
    Safes,
}) {
    const { t } = useTranslation(["forms"]);
    const claslbl = useStylesLbl();

    return (
        <>
            <div className="oc-filter-toolbar">
                <div className="oc-filters">

                    <TextField
                        variant="outlined"
                        size="small"
                        type="date"
                        label={t("date-from")}
                        value={rptParams.dateFrom}
                        InputProps={{ className: claslbl.clrSafe }}
                        onChange={(e) => setRptParams({ ...rptParams, dateFrom: e.target.value })}
                        InputLabelProps={{ shrink: true }}
                        className={`${classes.filter} oc-date-filter`}
                    />


                    <TextField
                        variant="outlined"
                        size="small"
                        type="date"
                        label={t("date-to")}
                        value={rptParams.dateTo}
                        InputProps={{ className: claslbl.clrSafe }}
                        onChange={(e) => setRptParams({ ...rptParams, dateTo: e.target.value })}
                        InputLabelProps={{ shrink: true }}
                        className={`${classes.filter} oc-date-filter`}
                    />
                    <Autocomplete
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            setRptParams({ ...rptParams, branch: newValue });
                        }}
                        id="combo-box-demo"
                        size="small"
                        options={Branches}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true }}
                                label={t("branch")}
                                variant="outlined"
                            />
                        )}
                    />

                    <Tooltip title={t("refresh-data")}>
                        <IconButton className="oc-refresh-button"
                            onClick={viewHandle}>
                            <Refresh />
                        </IconButton>
                    </Tooltip>


                </div>
                <div className="oc-dashboard-heading">

                    <div className="oc-dashboard-heading-icon">
                        <AssessmentOutlined />
                    </div>

                    <div>

                        <Typography className="oc-dashboard-title">
                            {t("dashboard")}
                        </Typography>

                        <Typography className="oc-dashboard-subtitle">
                            {t("today-overview")}
                        </Typography>

                    </div>

                </div>
            </div>

        </>
    );
}


// ======================================================
// الشريط السفلي
// ======================================================

function DashboardFooter({ classes }) {
    const { t } = useTranslation(["forms"]);
    const [language, setLanguage] = React.useState("ar");

    return (
        <div className="oc-bottom-bar">

            <div className="oc-bottom-buttons">

                <Button
                    className={`${classes.bottomButton} oc-footer-home`}
                    startIcon={<Home />}
                >
                    {t("main-menu")}
                </Button>

                <Button
                    className={classes.bottomButton}
                    startIcon={<PersonOutline />}
                >
                    {t("user-information")}
                </Button>

                <Button
                    className={`${classes.bottomButton} oc-footer-icon-button`}
                >
                    <TrendingUp />
                </Button>

                <Button
                    className={`${classes.bottomButton} oc-footer-icon-button`}
                    onClick={() => window.location.reload()}
                >
                    <Refresh />
                </Button>

            </div>


            <div className="oc-language-buttons">

                <Button
                    className={
                        language === "en"
                            ? "oc-language-active"
                            : "oc-language-button"
                    }
                    onClick={() => setLanguage("en")}
                    startIcon={<Language />}
                >
                    English
                </Button>

                <Button
                    className={
                        language === "ar"
                            ? "oc-language-active"
                            : "oc-language-button"
                    }
                    onClick={() => setLanguage("ar")}
                >
                    {t("language-ar")}
                </Button>

            </div>


            <IconButton className="oc-footer-menu">
                <MenuIcon />
            </IconButton>

        </div>
    );
}


// ======================================================
// الصفحة الرئيسية
// ======================================================

export default function DashboardsNew(props) {
    const { Branches, Safes, curr } = props;
    const classes = useStyles();
    const { t } = useTranslation(["forms"]);
    const defalutParams = {
        dateFrom: moment(new Date()).format("YYYY-MM-DD"),
        dateTo: moment(new Date()).format("YYYY-MM-DD"),
        branch: { id: -1, name: t("all") },
        safe: { id: -1, name: t("all") },
    };

    const [rptParams, setRptParams] = useState(defalutParams);
    const [allData, setAllData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const viewHandle = async () => {
        setAllData([]);
        setFetching(true);
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `RptSales/dashboard?branch=${rptParams.branch.id}&&dateFrom=${rptParams.dateFrom}
            &&dateTo=${rptParams.dateTo}`
        } else {
            Urls = `RptSales/dashboard?branch=${rptParams.branch.id}&&dateFrom=${rptParams.dateFrom}
            &&dateTo=${rptParams.dateTo}&&db_name=${sto?.db_name}`
        }
        await axios
            .get(
                uri + Urls
            )
            .then((res) => {
                setAllData(res.data);
                console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                setFetching(false);
                console.log(err);
                // toast.err("يوجد خطأ في الجلب");
                setAllData([]);
            });
    };
    return (
        <div className={`${classes.root} oc-dashboard`} dir="ltr">

            {/* <DashboardHeader classes={classes} Branches={Branches} /> */}
            <DashboardHeader
                {...{
                    classes,
                    rptParams,
                    setRptParams,
                    Branches,
                    fetching,
                    viewHandle,
                    Safes,
                }}
            />

            <main className="oc-dashboard-content">

                <Grid container spacing={2}>

                    {/* العمود الأيسر: المخزون والمبالغ المحصلة */}




                    {/* القسم الرئيسي */}

                    <Grid item xs={12} md={8} lg={9}>

                        <div className="oc-main-column">

                            {/* البطاقات الإحصائية */}

                            <Grid container spacing={1.5}>

                                {kpiData(allData).map((item) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        lg={4}
                                        key={item.id}
                                    >

                                        <KpiCard
                                            item={item}
                                            classes={classes}
                                        // allData={allData}
                                        />

                                    </Grid>
                                ))}

                            </Grid>


                            {/* الرسوم البيانية */}

                            <Grid container spacing={1.5} className="oc-charts-row">

                                <Grid item xs={12} lg={7}>

                                    {/* <WeeklySalesChart
                                        classes={classes}
                                        data={allData}
                                    /> */}
                                    <LatestSales
                                        {...{
                                            data: allData ? allData.LatestSevenDaysSale : {},
                                            fetching,
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} lg={5}>
                                    {/* {allData.mostFiveSoldProducts?.length>0 &&  */}
                                    {/* <TopProductsChart
                                    classes={classes}
                                    data={ allData ? allData.mostFiveSoldProducts :[]}
                                    fetching={fetching}/> */}
                                    <MostSoled
                                        {...{
                                            // classes,
                                            data: allData ? allData.mostFiveSoldProducts : {},
                                            fetching,
                                        }}
                                    />


                                </Grid>

                            </Grid>


                            {/* المبيعات الشهرية */}

                            <Grid container spacing={1.5}>

                                <Grid item xs={12}>

                                    {/* <MonthlySalesChart
                                        classes={classes}
                                        currentYear={Array(12).fill(0)}
                                        previousYear={Array(12).fill(0)}
                                        data={allData ? allData?.YearMonthsSales : []}
                                    /> */}
                                    <YearSales
                                        {...{
                                            data: allData ? allData.YearMonthsSales : {},
                                            fetching,
                                        }}
                                    />
                                </Grid>

                            </Grid>


                        </div>

                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>

                        <div className="oc-left-column">
                            <CollectedAmountsCard
                                {...{
                                    classes,
                                    data: allData ? allData.sales : {},
                                    fetching,
                                    curr: props.curr,
                                }}
                            />
                            <LowStockCard classes={classes} Safes={props.Safes} />


                        </div>

                    </Grid>
                </Grid>

            </main>


        </div>
    );
}